import React from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";

const UserFormsListHeaderComponent = ({
  globalFilterValue,
  onGlobalFilterChange,
  clearFilter,
}) => {
  return (
    <div className="flex justify-content-between">
      <div className="flex">
        <IconField iconPosition="right">
          <InputIcon className="pi pi-search" />
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Keyword Search"
            style={{ fontFamily: "poppins" }}
          />
        </IconField>
        <Button
          type="button"
          icon="pi pi-filter-slash"
          label="Clear"
          outlined
          onClick={clearFilter}
          style={{
            backgroundColor: "#D97A07",
            border: "none",
            color: "#fff",
            marginLeft: "10px",
            fontFamily: "poppins",
          }}
        />
      </div>
    </div>
  );
};

export default UserFormsListHeaderComponent;
